'use client';

import { useLayoutEffect, useRef } from 'react';
import { readRewrittenTripId } from '~/hooks/useTripId';
import { useTripBookingStore } from '~/stores/tpv2/tripBookingStore';
import type { CurrencyName } from '~/utils/tpv2/currency';

type Props = {
  initialCurrency: CurrencyName;
  tripId: string;
};

export const TripBookingStoreInitializer = ({ initialCurrency, tripId }: Readonly<Props>) => {
  const initializeCurrency = useTripBookingStore((s) => s.initializeCurrency);
  const setActiveTripId = useTripBookingStore((s) => s.setActiveTripId);
  const currencyInitialized = useRef(false);

  if (!currencyInitialized.current) {
    currencyInitialized.current = true;
    initializeCurrency(initialCurrency);
  }

  useLayoutEffect(() => {
    if (!tripId) return;
    useTripBookingStore.getState().hydrateDatesConfirmed();
    setActiveTripId(readRewrittenTripId() || tripId);
  }, [tripId, setActiveTripId]);

  return null;
};
